export default {
  title: 'Tem a certeza de que quer terminar sessão?',
  buttons: {
    logout: 'Terminar sessão',
    cancel: 'Cancelar',
  },
};
